//TODO: Create a dynamic spinner so you can choose size, color, etc.
export const SmallSpinner = () => <div className="h-3 w-3 animate-spin rounded-full border-t-2 border-b-2 border-licorice-noir" />;
